import { render, staticRenderFns } from "./addGoodWay.vue?vue&type=template&id=592d7d0b&scoped=true&"
import script from "./addGoodWay.vue?vue&type=script&lang=js&"
export * from "./addGoodWay.vue?vue&type=script&lang=js&"
import style0 from "./addGoodWay.vue?vue&type=style&index=0&id=592d7d0b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592d7d0b",
  null
  
)

export default component.exports